import { schema } from 'normalizr'

const promoSchema = new schema.Entity(
    'promos',
    {},
    {
        idAttribute: 'promo_id',
    },
)
export const promosSchema = [promoSchema]
